/* pantallas-alumno (B): LA CAJA DE NUMERO CON BARRA (piezas nuevas de la parte 1; Settings del Centro).

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   - Etiqueta 13 px seminegrita #C8C8C8 y, a la derecha, el dato de 12.5 px #8A8A8A ("max 180").
   - Caja de 44 (48 en el celular, con texto de 16), fondo #0E0E0E, borde #2C2C2C, radio 12; la
     unidad ("min") adentro a la derecha. Foco: borde #F27A2E. Error: borde #F87171 y debajo el texto
     rojo de 13 px con su icono (parte renglon entero), unido a la caja por `aria-describedby`.
   - Barra deslizante (`BarraDeslizante`, aparte, para ponerla donde va): riel de 6 #262626, relleno
     #F27A2E, perilla de 18 blanca con borde de 3 naranja y area tactil de 44 (el control entero mide 44).
   - Apagada: 45 %.

   `onCambio` recibe el TEXTO de la caja (la pantalla decide como lo lee: la logica de hoy no cambia) y
   el NUMERO de la barra.

   centro-espacio-2 (orden de Carlos del 20-oct): `barra` pone la barra deslizante AL LADO de la caja, en
   el mismo renglon, como era antes del rediseno (se ahorra el renglon entero de las barras). Solo abajo de
   1024: desde ahi el renglon se deshace (sus dos piezas pasan a ser hijas de la columna) y todo queda
   apilado exactamente como antes, con el error entre la caja y la barra. Abajo de 1024 la caja mide
   `anchoDeLaCaja` y, con unidad, su relleno se aprieta lo justo para tres cifras y la unidad; la letra y
   el alto no cambian. Sin `barra`, todo igual que antes.
   En el celular (abajo de 768) se aprieta lo justo para que Exam quepa: la caja de 48 a 44 (el minimo de un toque; la
   letra sigue en 16), el renglon de la etiqueta a 16 y su separacion de 6 a 4. */
import React from 'react';
import { AlertCircle } from 'lucide-react';

export default function CajaDeNumero({
  id, etiqueta, dato, unidad, valor, onCambio, error, apagada = false, testid, min, max, inputProps = {}, children,
  barra = null, anchoDeLaCaja = 'w-16',
}) {
  const idError = error ? `${id}-error` : undefined;
  const alLado = barra != null;
  const relleno = unidad
    ? (alLado ? 'px-3.5 pr-12 max-lg:px-2.5 max-lg:pr-10' : 'px-3.5 pr-12')
    : 'px-3.5';
  const caja = (
    <div className={alLado ? `relative shrink-0 ${anchoDeLaCaja} lg:w-auto` : 'relative'}>
      <input
        id={id}
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        value={valor}
        min={min}
        max={max}
        disabled={apagada}
        aria-invalid={error ? 'true' : undefined}
        aria-describedby={idError}
        onChange={(e) => { if (onCambio) onCambio(e.target.value); }}
        className={`w-full ${alLado ? 'h-11' : 'h-12 md:h-11'} ${relleno} rounded-xl bg-[#0E0E0E] border text-[16px] md:text-[14px] text-[#F4F4F3] tabular-nums outline-none focus:border-[#F27A2E] disabled:cursor-not-allowed ${error ? 'border-[#F87171]' : 'border-[#2C2C2C]'}`}
        {...inputProps}
      />
      {unidad ? <span data-parte="unidad" className={`pointer-events-none absolute ${alLado ? 'right-3.5 max-lg:right-2.5' : 'right-3.5'} top-1/2 -translate-y-1/2 text-[13px] text-[#8A8A8A]`}>{unidad}</span> : null}
    </div>
  );
  return (
    <div data-testid={testid} className={`flex flex-col gap-1.5 ${alLado ? 'max-md:gap-1 ' : ''}min-w-0${apagada ? ' opacity-45' : ''}`}>
      <div className={alLado ? 'flex items-baseline justify-between gap-3 max-md:leading-4' : 'flex items-baseline justify-between gap-3'}>
        <label htmlFor={id} className="text-[13px] font-semibold text-[#C8C8C8]">{etiqueta}</label>
        {dato ? <span data-parte="dato" className="text-[12.5px] text-[#8A8A8A] tabular-nums">{dato}</span> : null}
      </div>
      {alLado ? (
        <div data-parte="renglon" className="flex items-center gap-2 lg:contents">
          {caja}
          <div data-parte="barra" className="flex-1 min-w-0 lg:order-2">{barra}</div>
        </div>
      ) : caja}
      {error ? (
        <p id={idError} data-parte="error" className={`flex items-start gap-1.5 text-[13px] leading-[18px] text-[#F87171]${alLado ? ' lg:order-1' : ''}`}>
          <AlertCircle className="w-3.5 h-3.5 shrink-0 mt-0.5" aria-hidden="true" />
          <span className="min-w-0 break-words">{error}</span>
        </p>
      ) : null}
      {children}
    </div>
  );
}

const PERILLA = '[&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-[18px] [&::-webkit-slider-thumb]:h-[18px] [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-white [&::-webkit-slider-thumb]:border-[3px] [&::-webkit-slider-thumb]:border-solid [&::-webkit-slider-thumb]:border-[#F27A2E] [&::-webkit-slider-thumb]:cursor-pointer [&::-moz-range-thumb]:w-[18px] [&::-moz-range-thumb]:h-[18px] [&::-moz-range-thumb]:box-border [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:bg-white [&::-moz-range-thumb]:border-[3px] [&::-moz-range-thumb]:border-solid [&::-moz-range-thumb]:border-[#F27A2E] [&::-moz-range-track]:bg-transparent [&::-webkit-slider-runnable-track]:bg-transparent';

export function BarraDeslizante({ etiqueta, min = 0, max = 100, paso = 1, valor, onCambio, apagada = false, testid }) {
  const n = Number(valor);
  const lo = Number(min);
  const hi = Number(max);
  const pct = Number.isFinite(n) && hi > lo ? Math.min(100, Math.max(0, ((n - lo) / (hi - lo)) * 100)) : 0;
  return (
    <div data-testid={testid} className={`relative h-11 flex items-center${apagada ? ' opacity-45' : ''}`}>
      <div data-parte="riel" aria-hidden="true" className="absolute left-[9px] right-[9px] top-1/2 -translate-y-1/2 h-1.5 rounded-full bg-[#262626] overflow-hidden">
        <div data-parte="relleno" className="h-full rounded-full bg-[#F27A2E]" style={{ width: `${pct}%` }} />
      </div>
      <input
        type="range"
        aria-label={etiqueta}
        min={min}
        max={max}
        step={paso}
        value={Number.isFinite(n) ? n : lo}
        disabled={apagada}
        onChange={(e) => { if (onCambio) onCambio(Number(e.target.value)); }}
        className={`relative w-full h-11 m-0 bg-transparent appearance-none cursor-pointer disabled:cursor-not-allowed focus:outline-none focus-visible:[&::-webkit-slider-thumb]:shadow-[0_0_0_2px_#FFFFFF] focus-visible:[&::-moz-range-thumb]:shadow-[0_0_0_2px_#FFFFFF] ${PERILLA}`}
      />
    </div>
  );
}
